import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiClientConfig} from '../api-client-config';
import {ListTreatDpiaComment} from "it/primatoo/openapi/api/org/schemas/treatmentcomment/ListTreatDpiaComment";
import {
  CreateTreatDpiaCommentRequest
} from "it/primatoo/openapi/api/org/schemas/treatmentcomment/CreateTreatDpiaCommentRequest";
import {
  CreateTreatDpiaCommentResponse
} from "it/primatoo/openapi/api/org/schemas/treatmentcomment/CreateTreatDpiaCommentResponse";
import {
  UpdateTreatDpiaCommentRequest
} from "it/primatoo/openapi/api/org/schemas/treatmentcomment/UpdateTreatDpiaCommentRequest";

@Injectable({
  providedIn: 'root'
})
export class DpiaCommentsService {
  private readonly endPoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    private httpClient: HttpClient) {
    this.endPoint = this.config.endPoint + '/api/org/v2/docs/treatments/';
  }

  public createComment(dpiaDocId: number, commentCreateRequest: CreateTreatDpiaCommentRequest): Observable<CreateTreatDpiaCommentResponse> {
    const url = this.endPoint + `${dpiaDocId}/comments/`;
    return this.httpClient.post<CreateTreatDpiaCommentResponse>(url, commentCreateRequest);
  }


  public updateComment(docId: number, commentId: number, commentCreateRequest: UpdateTreatDpiaCommentRequest): Observable<void> {
    const url = this.endPoint + `${docId}/comments/${commentId}/`;
    return this.httpClient.put<void>(url, commentCreateRequest);
  }

  public deleteComment(docId: number, commentId: number): Observable<void> {
    const url = this.endPoint + `${docId}/comments/${commentId}/`;
    return this.httpClient.delete<void>(url);
  }


  public getComments(docId: number): Observable<ListTreatDpiaComment> {
    // const url = this.endPoint + `${dpiaDocId}/comments/?type=${CommentType.ASSESSMENT}`;
    const url = this.endPoint + `${docId}/comments/`;

    return this.httpClient.get<ListTreatDpiaComment>(url);
  }

}
